/**
 * We need the token when using axios so we share it via a local cache
 * Todo: Maybe merge with clientConfig if this will survive
 */
export let tokenCache = {
  token: '',
};

export function updateTokenCache(token: string): void {
  tokenCache.token = token;
}
/**
 * we work with idTokens and not access tokens
 *
 * Todo: improve this!
 * https://learn.microsoft.com/de-de/entra/identity-platform/id-tokens
 */
export function getToken() {
  const token = tokenCache.token;

  // this should never happen - improve if you see facing a user
  // if (!token?.length) throw new Error('No auth token found - please login');
  // logYellow('getToken', token);
  return token;
}
